import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "bsPrefix"];

var _jsxFileName = "/opt/build/repo/src/NavbarCollapse.tsx",
    _this = this;

import React from 'react';
import PropTypes from 'prop-types';
import Collapse from './Collapse';
import { useBootstrapPrefix } from './ThemeProvider';
import NavbarContext from './NavbarContext';
var propTypes = {
  /** @default 'navbar-collapse' */
  bsPrefix: PropTypes.string
};
var NavbarCollapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-collapse');
  return /*#__PURE__*/React.createElement(NavbarContext.Consumer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, function (context) {
    return /*#__PURE__*/React.createElement(Collapse, _extends({
      in: !!(context && context.expanded)
    }, props, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: bsPrefix,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 13
      }
    }, children));
  });
});
NavbarCollapse.displayName = 'NavbarCollapse';
NavbarCollapse.propTypes = propTypes;
export default NavbarCollapse;